/**
 * TeamMemberCard Component
 *
 * Diamond Architecture: Team member card matching Rails About::TeamMembersComponent.
 *
 * Card layout:
 * - Square photo at top
 * - Name + title + bio quote below
 * - Bordered card with muted background
 */
import Image from '@/shared/components/ui/Image';
import { plainText, type AssetPath, type LocalizedText } from '@letsgethome/types/branded';

interface TeamMemberCardProps {
  /** Person name (proper noun) — pass via `plainText()`. */
  name: LocalizedText;
  title: LocalizedText;
  bio: LocalizedText;
  image: AssetPath;
  companyName: LocalizedText;
}

export function TeamMemberCard({ name, title, bio, image, companyName }: TeamMemberCardProps) {
  return (
    <div className="w-full max-w-sm border rounded-2xl bg-muted text-center shadow-lg overflow-hidden">
      <Image
        src={image}
        alt={plainText(`${companyName} ${title} photo`)}
        width={400}
        height={400}
        className="w-full aspect-square object-cover object-top"
        unoptimized
      />
      <div className="p-6 md:p-8">
        <h3 className="text-xl font-semibold">{name}</h3>
        <p className="text-sm text-primary mt-1">{title}</p>
        {/* eslint-disable-next-line i18next/no-literal-string -- typographic quotes around dynamic content */}
        <p className="text-muted-foreground italic mt-4">&ldquo;{bio}&rdquo;</p>
      </div>
    </div>
  );
}
